import { render, staticRenderFns } from "./HrAdvantages.vue?vue&type=template&id=796cd386"
import script from "./HrAdvantages.vue?vue&type=script&lang=js"
export * from "./HrAdvantages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports